export default "__VITE_ASSET__CTEiYSQB__"